export default "__VITE_ASSET__D9tWwZ9K__"